import { render, staticRenderFns } from "./PaymentDemo.vue?vue&type=template&id=523aeb59&"
import script from "./PaymentDemo.vue?vue&type=script&lang=js&"
export * from "./PaymentDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports